import { Plane } from 'lucide-react';
import { AffiliatePartnerCard } from '@/components/affiliate/AffiliatePartnerCard';
import { useAffiliatePartnersByTags } from '@/hooks/useAffiliatePartners';

interface BlogAffiliateRecommendationsProps {
  tags: Array<{ id: string; name: string }>;
  isNavigating?: boolean;
}

export const BlogAffiliateRecommendations = ({ 
  tags, 
  isNavigating = false 
}: BlogAffiliateRecommendationsProps) => {
  const tagIds = tags.map(tag => tag.id);
  const { data: partners, isLoading } = useAffiliatePartnersByTags(tagIds);

  if (isNavigating || isLoading || !partners || partners.length === 0) {
    return null;
  }

  return (
    <section className="my-12 py-8 border-t border-border">
      <div className="flex items-center gap-2 mb-6">
        <Plane className="h-5 w-5 text-primary" />
        <h3 className="text-xl font-semibold">Recommended Travel Resources</h3>
      </div>
      <p className="text-muted-foreground mb-6">
        Planning your trip? Check out these trusted partners to book flights, hotels, tours, and more.
      </p>
      <div className="space-y-4">
        {partners.map((partner) => (
          <AffiliatePartnerCard key={partner.id} partner={partner} compact />
        ))}
      </div>
    </section>
  );
};
